import { EmailInviteInput } from "../components/EmailInviteInput";
import type { StepProps } from "../types";

export function StepInviteMembers({ answers, setAnswer }: StepProps) {
  return (
    <div className="max-w-lg">
      <EmailInviteInput
        emails={answers.inviteEmails}
        onChange={(emails) => setAnswer("inviteEmails", emails)}
      />
    </div>
  );
}
